import * as React from 'react';
import clone from 'clone';
import { SurveyTxt } from '../../SurveyTxt';
import { SurveyAnswerOkStatus, LanguageCode, SurveySegmentation } from '../../amorg-common';
import { SelectField } from '../../designSystem/formField/SelectField';
import { ButtonRow } from '../../designSystem/button/ButtonRow';
import { Button } from '../../designSystem/button/Button';
import { Card } from '../../designSystem/Card';
import { H2 } from '../../designSystem/typography/Heading';
import { P } from '../../designSystem/typography/Body';
import { SurveySegment } from '../../amorg-common';
import { Flex } from '../../designSystem/compositeComponents/FlexHelpers';

type SetSegmentsProps = {
    txt:SurveyTxt,
    selectedLanguage:LanguageCode,
    answerStatus:SurveyAnswerOkStatus,
    onSubmitSegments: (segments:SurveySegment[]) => void
}
type State = {
    selections: SurveySegment[]
}
export function SetSegments(props: SetSegmentsProps): JSX.Element {

    const [state, setState] = React.useState<State>({
        selections: props.answerStatus.survey.segmentations.map(c => { return { name: c.name, value: '' } })
    });

    function handleSegmentChange(name: string, value: string) {
        let selections = clone(state.selections);
        selections = selections.filter(s => s.name !== name);
        selections.push({ name: name, value });
        setState({ ...state, selections });
    }

    async function handleSubmitSegments() {
        props.onSubmitSegments(state.selections);
    }

    function getSegmentationNameText(ss:SurveySegmentation):string
    {
        if(props.selectedLanguage === props.answerStatus.defaultLanguage)
            return ss.name;
        else
            return ss.translations.find(t => t.languageCode === props.selectedLanguage).name;
    }

    function getSegmentationValueText(ss:SurveySegmentation, index:number):string
    {
        if(props.selectedLanguage === props.answerStatus.defaultLanguage)
            return ss.values[index];
        else
            return ss.translations.find(t => t.languageCode === props.selectedLanguage).values[index];
    }

    return (
        <>
            <Flex flexDirection="column" gap={24}>
                <H2>{props.txt.setSegments_header}</H2>
                
                {props.answerStatus.isCompleted &&
                    <P><i>{props.txt.setSegments_overwriteWarning}</i></P>
                }
                <P>{props.txt.setSegments_introText}</P>
                {props.answerStatus.survey.segmentations.map(c => {
                    return (
                        <SelectField key={c.name}
                            id={`selector-${c.name}`}
                            label={getSegmentationNameText(c)}
                            selectedValue={state.selections.find(s => s.name === c.name).value}
                            onChange={(newValue) => { handleSegmentChange(c.name, newValue) }}
                            options={
                                [{ text:props.txt.setSegments_selectText, value:'' },
                                ...c.values.map((v,i) => new Option(getSegmentationValueText(c,i), v))
                                ]
                            }
                        />
                    );
                })}
                <ButtonRow marginTop={20}>
                    <Button variant="filled" 
                        onClick={handleSubmitSegments} 
                        text={props.txt.setSegments_buttonNextText}
                        disabled={state.selections.find(s => s.value === '') !== undefined} />
                </ButtonRow>
                
            </Flex>
        </>
    );
}


